import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { PawPrint as Paw } from 'lucide-react';

export const ConfirmPage: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleEmailConfirmation = async () => {
      try {
        const { data: { session }, error: sessionError } = await supabase.auth.getSession();

        if (sessionError) throw sessionError;

        if (session?.user) {
          // Check if profile already exists
          const { data: existingProfile } = await supabase
            .from('profiles')
            .select('id')
            .eq('id', session.user.id)
            .single();

          if (!existingProfile) {
            // Create profile for the confirmed user
            const { error: profileError } = await supabase
              .from('profiles')
              .insert([
                {
                  id: session.user.id,
                  email: session.user.email,
                  username: session.user.email?.split('@')[0], // Temporary username
                  avatar_url: null,
                  full_name: '',
                  bio: '',
                }
              ]);

            if (profileError) throw profileError;
          }
          
          // Redirect to home page
          navigate('/', { replace: true });
        }
      } catch (err) {
        console.error('Confirmation error:', err);
        setError('Failed to confirm your email. Please try again or contact support.');
      }
    };

    handleEmailConfirmation();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <Paw className="h-12 w-12 text-purple-600" />
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Confirming your email
        </h2>
        {error ? (
          <div className="mt-4 bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-md text-sm text-center">
            {error}
          </div>
        ) : (
          <p className="mt-4 text-center text-gray-600">
            Please wait while we confirm your email...
          </p>
        )}
      </div>
    </div>
  );
}